import { Card, CardContent, CardHeader, FormControl, Icon, IconButton } from '@material-ui/core';
import ModalActions from 'components/ModalActions';
import { Field, Formik } from 'formik';
import React from 'react';
import { toast } from 'react-toastify';
import UrlValidationFormField from 'v2/components/Shared/UrlValidationFormField';
import deliveryProvidersService from 'v2/services/delivery-providers';
import * as yup from 'yup';

import type { DispatchProp } from 'react-redux';

const alpaclassObject = {
  id: 47,
  method_id: '47',
  method_name: 'AlpaClass',
  name: 'AlpaClass',
  parameters: {
    label: 'URL',
    name: 'url',
    regexp: '',
    required: true,
    size: 250,
  },
  type: 'CHECKOUT',
  url: '',
};
const urlRegex =
  /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;

interface IProps extends DispatchProp<any> {
  isModal: boolean;
  open?: boolean;
  onClose?: any;
  onOk: any;
  other?: any;
  offer?: any;
  newProduct?: boolean;
}

interface IStates {
  selected: any;
  defaultFields: any;
  open: boolean;
  urlIsValid: boolean;
}

class AlpaClass extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      selected: props.other ? Object.assign({}, { ...alpaclassObject, ...props.other }) : Object.assign({}, alpaclassObject),
      open: this.props.open,
      defaultFields: {},
      urlIsValid: false,
    };
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.props.onClose();
    this.setState({ open: false, selected: Object.assign({}, alpaclassObject) });
  };

  handleOk = () => {
    const onOk = this.props.onOk;
    let { selected } = this.state;
    let msg = '';
    let isValid = true;

    let url = urlRegex.test(String(selected.url).toLowerCase());
    if (!url) {
      msg = 'Por favor informe uma Url válida no campo URL';
      isValid = false;
    }

    if (selected && selected.id) {
      if (isValid) {
        if (onOk) {
          selected.new = true;
          selected.can_modify = true;
          onOk(selected, this.props.other);

          if (!this.props.other) {
            toast.success(`Item ${selected.name} adicionado com sucesso!`);
          }
          this.setState({ selected: Object.assign({}, alpaclassObject) });
          this.props.onClose();
        }
      } else {
        toast.warn(`${msg}`);
        msg = '';
      }
    } else {
      toast.warn('Por favor selecione uma forma de entrega do tipo outros');
    }
  };

  isOkButtonDisabled = () => {
    const { urlIsValid } = this.state;

    return !urlIsValid;
  };

  onChangeProp = (e: React.ChangeEvent<HTMLInputElement>) => {
    let selected = this.state.selected;
    selected.url = e.target.value;
    this.setState({ selected });
  };

  render() {
    const { isModal, open } = this.props;
    const { selected } = this.state;
    const title = 'Entrega de conteúdo na AlpaClass';
    const content = (
      <form>
        <FormControl style={{ width: '100%' }}>
          <Formik
            key={'alpaclass-delivery'}
            initialValues={{
              url: selected.url,
              type: 'url',
            }}
            validationSchema={yup.object().shape({
              url: yup
                .string()
                .required('Preencha o campo URL, obrigatório http:// ou https://')
                .url('Insira uma URL válida, obrigatório http:// ou https://'),
            })}
            onSubmit={(values) => alert(JSON.stringify(values, null, 2))}
          >
            <div>
              <Field
                name='url'
                helperText='Insira uma URL válida, obrigatório http:// ou https://'
                id={alpaclassObject.parameters.name}
                component={UrlValidationFormField}
                onValidateUrl={(isValid: boolean, url: string) => {
                  this.setState({ urlIsValid: isValid, selected: { ...this.state.selected, url } });
                }}
                validateUrlCallback={deliveryProvidersService.customTestUrl}
              />
            </div>
          </Formik>
        </FormControl>
        <div style={{ marginTop: 16 }}>
          <p>
            Ainda não tem conta na AlpaClass?{' '}
            <a href='https://alpaclass.com' target='_blank' rel='noopener noreferrer'>
              Clique Aqui
            </a>
          </p>
        </div>
      </form>
    );
    return (
      <div>
        {isModal ? (
          <ModalActions
            buttonOk='Salvar'
            buttonOkDisabled={this.isOkButtonDisabled()}
            title={title}
            open={open}
            onClose={this.handleClose}
            onOk={this.handleOk}
          >
            {content}
          </ModalActions>
        ) : (
          <Card>
            <CardHeader
              title={title}
              action={
                <IconButton>
                  <Icon>clear</Icon>
                </IconButton>
              }
            />
            <CardContent>{content}</CardContent>
          </Card>
        )}
      </div>
    );
  }
}
export default AlpaClass;
